import { render, staticRenderFns } from "./select.vue?vue&type=template&id=2c95777a"
import script from "./select.js?vue&type=script&lang=js&external"
export * from "./select.js?vue&type=script&lang=js&external"
import style0 from "./select.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports